import React from 'react';

const TermsConditions = () => {
  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center text-left justify-center px-4">
      <h1 className="text-4xl font-bold mb-6">TERMS & CONDITIONS</h1>
      <div className="text-lg  max-w-2xl space-y-4 text-left">
        <p  className=" text-left" >GamesGalleria is a gaming and entertainment portal. This portal covers a wide range of mental skills. This portal has plenty of popular games like racing, skills, adventure, and sports that will give users the sparks their skills and creativity.</p>
        <p  className=" text-left">The service cost is KSH 15/day.</p>
        <p  className=" text-left">Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</p>
        <p  className=" text-left">You can unsubscribe from GamesGalleria, anytime.</p>
        <p  className=" text-left">You must be more than 14+ to have received permission from your parents or guardian who is authorized to pay your bill.</p>
        <p  className=" text-left">All data-enabled features and smartphone users can enjoy full service.</p>
        <p  className=" text-left">Customer can access the content at any time during the subscription validity period.</p>
      </div>
    </div>
  );
}

export default TermsConditions;
